<template>
  <div
    id="adjustment_modal"
    class="modal modal-right fade footer-fix"
    data-backdrop="static"
    role="dialog"
    ref="adjustment_modal"
  >
    <div
      class="modal-dialog  modal-xl"
      role="document"
    >
      <div
        class="modal-content"
        ref="section"
      >
        <div class="modal-header bg-dark">
          <h6
            class="modal-title"
          >
            {{ $t('Create Quantity Adjustments') }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div v-if="!isload">
          <div
            v-if="!hasPermission"
            class="modal-body p-0 pb-5 px-0"
          >
            <access-denied
              :show-button="true"
              :is-close-modal="true"
            />
          </div>
          <div
            v-if="hasPermission"
            class="modal-body p-0 pb-5 px-0"
          >
            <div class="px-0">
              <legend
                class="font-size-lg px-3 py-2 text-title-adjustment"
                style="margin-bottom: 15px;"
              >
                <i class="fa-solid fa-circle-exclamation" />

                {{ $t("Quantity Adjustments Information") }}
              </legend>
            </div>

            <div class="card px-3 mb-0 border-0 rounded-0 shadow-0">
              <div class="card-body p-0 ">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="text-title-adjustment">
                        {{ $t("Warehouse") }}
                        <span class="text-danger">*</span>
                      </label>
                      <Select2
                        id="warehouse"
                        v-model="newAdjustment.warehouse"
                        :options="myWareOptions"
                        :settings="settingOptionWare"
                        @change="onChangeWarehouse"
                        :placeholder="$t('Search by warehouse...')"
                        class="border-0 "
                        disabled
                      />
                      <span
                        v-if="submitStatus"
                        class="validation-invalid-label"
                        v-html="errors['warehouse']"
                      />
                      <span
                        v-if="!$v.newAdjustment.warehouse && submitStatus"
                        class="validation-invalid-label"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="text-title-adjustment">
                        {{ $t("Reference No.") }}
                      </label>

                      <input
                        type="text"
                        class="form-control discount "
                        :placeholder="$t('Enter reference no...')"
                        v-model="newAdjustment.reference_no"
                      >
                      <!-- <p
                        v-if="submitStatus"
                        class="validation-invalid-label"
                        v-html="errors['reference_no']"
                      /> -->
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="text-title-adjustment">
                        {{ $t("_inventory.Attach file") }}
                      </label>
                      <div
                        class="alert alert-danger border-0 alert-dismissible"
                        v-if="isAlertImport"
                      >
                        <span class="text-danger-400">
                          <h5 class="fa-solid fa-circle-info pr-1 m-0" />
                          {{ $t(alertFileMessage) }}
                        </span>
                      </div>

                      <uploader-bootstrap
                        @change="getFiles"
                        :accept-files="options.acceptFiles"
                        class="uploadfile-adjustment"
                      />
                      <label
                        class="text-grey-BFBFBF"
                        style="text-transform: none;margin-top: -20px;"
                      >
                        <i class="fa-regular fa-circle-exclamation" />
                        {{ $t("You can choose to upload a maximum of 1 files. The size is not over 30 MB. (File extensions supported by .png, .jpeg, .pdf, .xlsx)") }}
                      </label>
                      <span
                        v-if="newAdjustment.attachment_name == null && alertFileMessage == ''"
                        class="text-select-file"
                      >{{ $t("_inventory.Attach File") }}...</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="text-title-adjustment">
                        {{ $t("Remark") }}
                      </label>
                      <textarea
                        v-model="newAdjustment.remark"
                        rows="5"
                        class="form-control"
                        :placeholder="$t('Enter remark...')"
                      />
                      <label
                        class="validation-invalid-label"
                        for="remark"
                        v-if="!$v.newAdjustment.remark.maxLength && submitStatus"
                      >
                        {{ $t("Please enter no more than 255 characters.") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- item -->
            <div class="px-0">
              <legend
                class="font-size-lg px-3 py-2 "
                style="margin-bottom: 15px;"
              >
                <i class="fa-box-taped fa-solid mr-1 text-title-adjustment" />
                {{ $t("Products Items") }}
              </legend>
            </div>
            <div class="card px-3 border-0 rounded-0 shadow-0">
              <OrderItem
                v-if="renderComponent"
                ref="orderItem"
                :order_item="newAdjustment.items"
                :warehouse-id="newAdjustment.warehouse"
              />
            </div>
          </div>
          <div
            v-if="hasPermission"
            class="card-footer fixed-bottom bg-light d-flex justify-content-between"
          >
            <div>
              <button
                @click="previous()"
                type="button"
                class="btn btn-light text-left"
              >
                <i class="fas fa-arrow-circle-left mr-2"></i>
                {{ $t("Previous") }}
              </button>
            </div>
            <div>
              <ladda
                :text="$t('Save')"
                :class="[!validate ? 'bg-primary' : 'bg-primary',]"
                :btn-class="'btn btn-primary mr-'"
                :loading="loadingLadda"
                icon="<i class='fa-solid fa-floppy-disk '></i>"
                @click="submit()"
              />


              <button
                type="button"
                class="ml-2 mr-2 btn btn-light"
                data-dismiss="modal"
                @click="closeModal"
              >
                {{ $t("Cancel") }}
              </button>
            </div>
            <div></div>
          </div>
        </div>
        <div
          v-if="isload"
        >
          <div class="">
            <div class="content">
              <placeholder-content is-load="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import Api from "@/services/endpoint/tenant.service.js";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import Select2 from 'v-select2-component';
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue'
import moment from 'moment'
import OrderItem from './OrderItem'
import numeral from 'numeral'
import UploaderBootstrap from "./UploaderBootstrap.vue";


export default {
  name: "ActionAdjustmentsModal",
  components: {
    PlaceholderContent,
    Select2,
    AccessDenied,
    Ladda,
    OrderItem,
    UploaderBootstrap
  },
  props: {
    adjustmentBody: {
      type: [Object],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      submitStatus: false,
      loadingLadda: false,
      onload: true,
      isload: true,
      onloadLocation: true,
      hasPermission: false,
      renderComponent: true,
      urlProduct: '',
      newAdjustment: {
        reference_no: "",
        warehouse: null,
        remark: "",
        dateRange: {
          startDate: null,
          endDate: null,
        },
        countItemAll: 0,
        items: [],
        attachment: null,
        attachment_name: null
      },
      myWareOptions: [],
      settingOptionWare: {
        placeholder: {
          id: "",
          text: this.$t("Select warehouse") + '...',
        },
        templateResult: this.templateCustom,
        templateSelection: this.templateSelectWarehouse,
        ajax: {
          cache: true,
          delay: 250,
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", 'Bearer ' + Api.AUTH.TOKEN);
          },
          url: Api.AUTH.URL + Api.URL.ADJUSTMENTS_GETWAREHOUSE,
          data: function (params) {

            const query = {
              search: params.term,
              page: params.page || 1,
              limit: params.limit || 10
            }
            return Api.Signature.create($.param(query)).substring(1);
          },
          processResults: (data) => {
            let option = data.data;
            let pageCurrent = data.meta.current_page

            option = option.map(function (item) {
              return {
                id: item.id,
                text: item.name,
                color: item.color,
                ctid: item.id,
              }
            })
            return {
              results: option,
              pagination: {
                more: (pageCurrent * 10) < data.meta.total
              }
            };
          }
        }
      },
      taxOptions: [
        { id: 1, text: this.$t("Enable Vat") },
        { id: 0, text: this.$t("Disable Vat") },
      ],
      taxSettings: {
        minimumResultsForSearch: Infinity,
      },
      errors: [],
      isAlertImport: false,
      alertFileMessage: '',
      files: [],
      options: {
        acceptFiles: '*'
      },
      allowedFileExtensions: [
        // 'text/csv',
        // 'application/pdf',
        'application/vnd.ms-excel',
        'image/png',
        'image/jpeg',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ],
      isAddProduct: false,
      paramsQuery: {
        search: null,
        limit: 10,
        page: 1,
        status: "active",
        product_ids: [],
      },
      queryString: "",
    }
  },
  async created() {
    await this.fetchData();
  },
  mounted() {
    this.openModal();
    this.afterCloseModal();
  },
  validations: {
    newAdjustment: {
      warehouse: {
        required,
      },
      remark: {
        maxLength: maxLength(255)
      },

    }
  },
  methods: {
    async fetchData() {
      this.isload = true;

      if (Object.keys(this.adjustmentBody).length) {
        this.newAdjustment.warehouse = this.adjustmentBody.warehouse.id;

        this.myWareOptions.push({
          'id': this.adjustmentBody.warehouse.id,
          'text': this.adjustmentBody.warehouse.name,
        });

        this.paramsQuery.product_ids = this.adjustmentBody.adjustment_items.map(item => item.id);

        let queryString = "";
        if (this.paramsQuery) {
          queryString += "?" + $.param(this.paramsQuery);
        }

        this.queryString = queryString;

        await this.getProductItem();
      } else {
        // handle code page quantity adjustment
      }

      this.isload = false;
    },
    async getProductItem() {
      try {
        let response = await Api.Adjustments.getProductPromotion(this.newAdjustment.warehouse, this.queryString);
        const temp = []
        const res = response.data.data
        for (let el of res) {
          const findProducts = this.adjustmentBody.adjustment_items.find(item => item.id == el.id)
          if (findProducts) {
            temp.push({
              "id": el.id,
              "product_id": el.id,
              "available_qty": el.available_qty,
              "sku": el.sku,
              "name": el.name,
              "image": el.image,
              "quantity": findProducts.quantity,
              "type_adj": 'subtraction',
            })
          }
        }
        this.newAdjustment.items = temp
        this.hasPermission = true;
        this.onloadLocation = false;

      } catch (error) {
        console.log(error);
        this.hasPermission = false;
        this.onloadLocation = false;
        this.isload = false;
      }
    },
    async submit() {
      let self = this
      this.loadingLadda = true;
      this.submitStatus = true;

      if (!this.$v.$invalid && this.newAdjustment.items.length > 0 && this.errors.length == 0) {
        const mappedData = this.newAdjustment.items.map((item, index) => {
          // Add the "app" property to each object with a unique value (index + 1)
          return {
            ...item,
            available_qty: Number(item.available_qty),
            type: item.type_adj == "addition" ? "in" : "out",
            cost: Number(item.cost),
            total: Number(item.total) == 0 ? 1 : Number(item.total)
          };
        });
        let dataSubmit = {
          "warehouse_id": parseInt(this.newAdjustment.warehouse),
          "items": mappedData
        }
        if (this.newAdjustment.reference_no != "") {
          let referenceNo = {
            "reference_id": this.newAdjustment.reference_no
          }
          Object.assign(dataSubmit, referenceNo);
        }
        if (this.newAdjustment.attachment_base64 != null) {
          let attachment = {
            "attachments": [
              {
                "base64": this.newAdjustment.attachment_base64,
                "file_name": this.newAdjustment.attachment_name
              }
            ]
          }

          Object.assign(dataSubmit, attachment);
        }
        if (this.adjustmentBody != []) {
          Object.assign(dataSubmit,
            {
              model: "restock",
              product_ids: this.adjustmentBody.product_ids,
              order_ids: this.adjustmentBody.order_ids
            });
        }

        if (this.newAdjustment.remark != "") {
          let remark = {
            "remark": this.newAdjustment.remark
          }
          Object.assign(dataSubmit, remark);
        }
        try {
          let response = await Api.Adjustments.createAdjustments(dataSubmit);
          switch (response.status) {
            case 200:
              this.$toastr.s(
                this.$t("Create Quantity Adjustment Success."),
                "<i class='fa-solid fa-circle-check mr-2'></i>" + this.$t("Success")
              );
              this.$store.dispatch("inventory/refreshAlertRestock", true);
              this.closeModal();
              break;

            case 403:
              self.$swal({
                icon: false,
                iconColor: "#FF7043",
                title: self.$t("Access Denied"),
                html:
                  self.$t("You do not have permission to access this page.") +
                  "<br/>" +
                  self.$t(
                    "If you feel this is a mistake, contact your admin."
                  ),
                showCancelButton: false,
                confirmButtonText:
                  '<i class="fa-solid fa-circle-check fa-1x mr-1"></i> ' +
                  self.$t("Got It!"),

                imageUrl: require("@/assets/images/activities/icon-access-denied.png"),
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-primary mr-2",
                  cancelButton: "btn btn-light"
                },
                focusConfirm: false,
                showLoaderOnConfirm: true,
                popup: "validation-access-denied"
              });
              this.closeModal();
              break;

            default:
              this.$toastr.e(
                this.$t("Create Quantity Adjustment Failed."),
                "<span class='icon-blocked'></span>" + this.$t("Failed")
              );
              this.loadingLadda = false;
              this.closeModal();
              break;
          }
        } catch (err) {
          self.loadingLadda = false;
          self.closeModal();
          self.$toastr.e(
            self.$t("Create Quantity Adjustment Failed."),
            "<span class='icon-blocked'></span>" + self.$t("Failed")
          );
        }

      } else {
        this.loadingLadda = false;
      }
    },
    onChangeWarehouse(warehouseId) {
      //
      // this.urlProduct = Api.AUTH.URL + Api.URL.INVENTORY_GETPRODUCT + '/' + id + '/products'
    },
    openModal() {
      $("#adjustment_modal").modal("show");
    },
    closeModal() {
      $('#adjustment_modal').modal('hide');
    },
    afterCloseModal() {
      $('#adjustment_modal').on('hidden.bs.modal', () => {
        this.submitStatus = false;
        this.loadingLadda = false;

        if (this.$storeIndex.isset(() => this.$parent.isAdjustmentModal)) {
          this.$parent.isAdjustmentModal = false;
        }
      });
    },
    previous() {
      this.closeModal();
      this.$parent.isRestockValidateModal = true;
      $("#adjustment_modal").on("hidden.bs.modal", (e) => {
        $("#modal_validate_restock").modal("show");
      });
    },
    updateOrderItem: function (data) {
      this.newAdjustment.items = data.items;
      this.newAdjustment.discount_type = data.discountType;
      let items = this.newAdjustment.items;
      let total = 0;
      let subTotal = 0;
      for (let i = 0; i < this.newAdjustment.items.length; i++) {
        let item = items[i];
        let total = item.total;
        let subTotal = item.sub_total;
        total = parseFloat(total) + parseFloat(total);
        subTotal = parseFloat(subTotal) + parseFloat(subTotal);
      }
      this.newAdjustment.total = total;
      this.newAdjustment.sub_total = subTotal;
    },
    async setValidateError(errors) {
      this.errors = errors;
    },
    getFiles(param) {
      if (param.file) {
        if (param.file.size <= 31457280) {
          if (this.allowedFileExtensions.includes(param.file.type)) {
            this.isAlertImport = false;
            const inputString = param.file.name;
            const lastIndex = inputString.lastIndexOf(".");
            const name = inputString.slice(0, lastIndex);

            this.newAdjustment.attachment_base64 = param.base64;
            this.newAdjustment.attachment_name = name;
          } else {
            this.alertFileMessage = this.$t('Invalid File Type. Please fix errors and upload the file again.');
            this.isAlertImport = true;
          }
        } else {
          this.alertFileMessage = this.$t('Files size is over 30 MB.');
          this.isAlertImport = true;
        }

      } else {
        this.isAlertImport = false;
        this.attachment = {};
      }
    },
    templateCustom: function (option) {
      if (!option.id) {
        return $(`<div class="loading-small p-0" style="z-index:9999; height:0;"></div>`);
      } else {

        if (!option.name) {
          option.name = option.text;
          if (!option.color) {
            option.color = '#26ADCA';
          }
        }
        let optionName = option.name;
        let colorTags = option.color;
        let txt = $(`<div class='list-item d-flex templatecustom'></div><div class='item-content'><div class='item-name'>${optionName}</div></div></div>`);
        return txt;
      }
    },
    async forceRerender() {
      // Remove MyComponent from the DOM
      this.renderComponent = false;

      // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;
    },
    templateSelectWarehouse: function (option) {
      if (!option.name) {
        option.name = option.text;
        option.color = '#26ADCA';
      }

      let optionName = option.name;
      let colorTags = option.color;
      let txt = $(`<div class='list-item d-flex templateselect'"><div class='item-content'><div class='item-name' style='color:#515151;'>${optionName}</div></div></div>`);
      return txt;
    },
  },
  computed: {
    validate: function () {
      let errors = [];

      if (!this.newAdjustment.items.length) {
        errors.push('items');
        errors['items'] = this.$t("Please select products.");
      }
      if (!this.newAdjustment.warehouse) {
        errors.push('warehouse');
        errors['warehouse'] = this.$t("Please enter Warehouse");
      }
      if (this.isAlertImport) {
        errors.push('attachment');
        errors['attachment'] = this.alertFileMessage;
      }

      if (this.newAdjustment.items) {
        let validateQuantity = [];
        validateQuantity = this.newAdjustment.items.filter(item => item.quantity > 9999999);
        if (validateQuantity.length > 0) {
          errors.push('quantity');
          errors['quantity'] = this.$t("Maximum value limit 9,999,999.");

        }
      }

      this.setValidateError(errors);
      if (errors.length > 0) {
        return false;
      } else {
        //this.onload = true;
        return true;
      }
    },

  },
  filters: {
    formatNumber: function (value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberNotZero(value) {
      return numeral(value).format("0,0");
    },
  },
}
</script>

<style>
.uploadfile-adjustment .input-group>.input-group-append>.btn,
.input-group>.input-group-append>.input-group-text,
.input-group>.input-group-prepend:first-child>.btn:not(:first-child),
.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),
.input-group>.input-group-prepend:not(:first-child)>.btn,
.input-group>.input-group-prepend:not(:first-child)>.input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #FAFAFA !important;
  color: #515151;
  border-color: #BFBFBF;
}

.search-warehosue .select2-container--default .select2-selection--multiple .select2-search--inline:first-child .select2-search__field {
  min-width: 12rem !important;
  max-width: 16.5rem !important;
}

.text-select-file {
  position: absolute;
  left: 25px;
  top: 35px;
  color: #BFBFBF;
  /* z-index: -1; */
}

.uploadfile-adjustment .file-input-new .file-caption-name,
.file-input-ajax-new .file-caption-name {
  color: #999;
  display: none;
}
.text-title-adjustment {
  color: #333333;
}
</style>




// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/AdjustmentsModal.vue